import GeoJSON from 'geojson'

import { AnyAirspace } from '@/domain/models/Airspace'

import { getAirspaceStackId } from '../../containers/MapStackPresenter'
import { MapGeoJsonLayer } from '../MapView/MapGeoJsonLayer'
import { MapGeoJsonSource } from '../MapView/MapGeoJsonSource'
import { getAirspaceDisplay } from './airspaceTypeRegistry'

interface MapActiveAirspaceProps {
  fillSourceId: string
  fillLayerId: string
  type: string
  feature: GeoJSON.Feature<GeoJSON.Polygon | GeoJSON.MultiPolygon, AnyAirspace>
}

function MapActiveAirspace(props: MapActiveAirspaceProps) {
  const { fillSourceId, fillLayerId, type, feature } = props

  return (
    <>
      <MapGeoJsonSource id={fillSourceId} data={feature}>
        <MapGeoJsonLayer
          types={['fill']}
          id={fillLayerId}
          sourceId={fillSourceId}
          beforeLayerId={getAirspaceStackId(type)}
          fillColor={getAirspaceDisplay(type).color}
          fillOpacity={0.2}
        />
      </MapGeoJsonSource>
    </>
  )
}

export { MapActiveAirspace }
